import { Pipe, PipeTransform } from '@angular/core';

const eventTypesMap = {
  assessment: 'Add assessment',
  quotation: 'Add quotation',
  quote_approved: 'Approve quote',
  waiting_for_parts: 'Waiting for parts',
  repair_started: 'Start job',
  completed: 'Complete job',
  cancelled: 'Cancel job'
};

@Pipe({
    name: 'buttonLabel',
    standalone: true
})
export class ButtonLabelPipe implements PipeTransform {
  transform(value: string): string {
    return eventTypesMap[value];
  }
}
